// The tour for whichever page is on screen, so the "?" in the nav bar can
// replay it without knowing which page it sits over. usePageTour registers on
// mount and clears on unmount; the nav bars show "?" only while one is set.
import { useSyncExternalStore } from "react";

let current = null;
const listeners = new Set();

export function setActiveTour(start) {
  current = start;
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// For a caller outside React's render, such as a menu item's click handler.
// False when the page on screen has no tour, so the caller can go somewhere
// that does rather than appear to do nothing.
export function startActiveTour() {
  if (!current) return false;
  current();
  return true;
}

export function useActiveTour() {
  return useSyncExternalStore(subscribe, () => current);
}
